<template>
  <div>
    <headerTop></headerTop>
    <div class="wrapper">
      <!-- 极配正品 -->
      <!-- <div class="header">
        <img src="@/assets/images/home/logo.png" class="logo" alt="" />
        <div style="position: relative;">
          <div style=" position: absolute;bottom: 0;right: 0; width: 135px;">
            正见 &nbsp; •&nbsp;&nbsp;正心&nbsp; •&nbsp;&nbsp;正品
          </div>
        </div>
      </div> -->
      <div class="content_button">
        <!-- 进度 -->
        <div class="flow">
          <div class="flowcontent">
            <div class="schedule">
              <div>
                <!-- <i class="iconfont icon-a-zu5361"></i> -->
                <img src="@/assets/images/refund/组 706.png" alt="" />
              </div>
              <div>买家申请售后</div>
            </div>
            <img class="img1" src="@/assets/images/refund/组 1613.png" alt="" />
            <div class="schedule">
              <div>
                <!-- <i class="iconfont icon-a-ziyuan35"></i> -->
                <img src="@/assets/images/refund/组 707.png" alt="" />
              </div>
              <div>卖家处理售后申请</div>
            </div>
            <img class="img1" src="@/assets/images/refund/组 1614.png" alt="" />
            <div class="schedule">
              <div>
                <!-- <i class="iconfont icon-a-ziyuan38"></i> -->
                <img src="@/assets/images/refund/组 1609.png" alt="" />
              </div>
              <div class="finish">售后处理完毕</div>
            </div>
          </div>
        </div>
        <div class="ty">
          <div class="testimony">
            <!-- 表单 -->
            <div class="Sheets">
              <Form
                ref="formValidate"
                :model="formValidate"
                :rules="ruleValidate"
                :label-width="100"
              >
                <Row type="flex">
                  <Col>
                    <FormItem label="服务类型:" prop="type">
                      <Select
                        style="width: 133px"
                        :label-in-value="true"
                        v-model="formValidate.type"
                        @on-change="change"
                      >
                        <Option
                          v-for="item in typeList"
                          :value="item.id"
                          :key="item.id"
                          >{{ item.name }}</Option
                        >
                        <!-- <Option value="2">退货退款</Option>
                        <Option value="3">仅退款</Option> -->
                        </Select>
                      <!-- <span style="margin-left: 5px">{{
                        particulars.type == 1 ? '退货' : '退货'
                      }}</span> -->
                      <!-- <span>{{ formValidate.type }}</span> -->
                    </FormItem>
                  </Col>
                  <Col class="yuanyin">
                    <FormItem label="原因:" prop="reason">
                      <Select
                        style="width: 200px"
                        :label-in-value="true"
                        @on-change="account"
                        v-model="formValidate.reason"
                      >
                        <Option value="1">不想要了</Option>
                        <Option value="2">购买配件无法使用</Option>
                        <Option value="3">商品成份描述不符</Option>
                        <Option value="4">卖家发错货</Option>
                        <Option value="5">商品破损</Option>
                        <Option value="6">其它</Option>
                        <Option value="7">缺货</Option>
                      </Select>
                    </FormItem>
                  </Col>
                </Row>
                <FormItem label="退货说明:" prop="desc">
                  <Input
                    v-model="formValidate.desc"
                    type="textarea"
                    show-word-limit
                    maxlength="200"
                    placeholder="  退货说明"
                  ></Input>
                </FormItem>
                <FormItem label="上传凭证:" prop="name">
                  <div class="Uploadshop">
                    <template>
                      <div
                        class="Anrikshow"
                        v-for="item in certificatelist"
                        :key="item"
                      >
                        <img class="showimg" :src="item" alt="" />
                        <!-- v-show="formValidate.logo" -->
                        <span class="deletelogo" @click="deletelogo(item)"
                          >×</span
                        >
                      </div>
                      <!-- v-show="formValidate.logo && stateaudit.auditStatus == 2" -->
                      <!-- </div> -->
                    </template>
                    <upload
                      :forbid="certificatelist.length == 10 ? true : false"
                      :options="options"
                      @getOssRes="certificate"
                    ></upload>
                    <div class="hint"><span>(最多上传10张图片)</span></div>
                  </div>
                </FormItem>
              </Form>
            </div>

            <div class="tkexplain">
              <!-- 退货单价请与卖家协商后进行填写， -->
              <div>退货单价请与卖家协商后进行填写，退款不包含运费</div>
            </div>
            <!-- 表格 -->
            <div class="sheet">
              <span class="returns"> 退货商品:</span>
              <vxe-table
                border
                ref="xTable3"
                size="mini"
                align="center"
                resizable
                show-overflow
                :data="tableData3"
                max-height="300"
                @checkbox-change="selectChangeEvent2"
                :edit-config="{
                  trigger: 'click',
                  mode: 'cell'
                }"
                @edit-actived="editActivedEvent"
                :edit-rules="validRules"
                :checkbox-config="{ trigger: 'click' }"
                @checkbox-all="selectChangeEventAll"
              >
                <vxe-column width="80" type="checkbox">
                  <!-- <template>
                    <vxe-checkbox
                      type="checkbox"
                      status="primary"
                    ></vxe-checkbox>
                  </template> -->
                </vxe-column>
                <vxe-column
                  field="fullName"
                  title="配件名称"
                  width="220"
                ></vxe-column>
                <vxe-column field="partName" title="发货地" width="220">
                  <template #default="{ row }">
                    <span> {{ row.shipCity }}{{ row.shipStore }} </span>
                  </template>
                </vxe-column>
                <vxe-column
                  field="partNum"
                  title="购买数量"
                  width="100"
                ></vxe-column>
                <!-- <vxe-column
            field="sellPrice"
            title="销售单价"
            width="120"
            :edit-render="{ autofocus: '.vxe-input--inner' }"
          >
            <template #edit="{ row }">
              <vxe-input
                @blur="transfer(row)"
                v-model="row.sellPrice"
                type="text"
              ></vxe-input>
            </template>
          </vxe-column> -->
                <vxe-column
                  field="refundableAmount"
                  title="可退数量"
                  width="100"
                ></vxe-column>
                <vxe-column
                  field="refundNumber"
                  title="退货数量"
                  width="120"
                  :edit-render="{ autofocus: '.vxe-input--inner' }"
                >
                  <template #edit="{ row }">
                    <vxe-input
                      v-model="row.refundNumber"
                      :max="row.refundableAmount"
                      min="1"
                      @blur="salesgoods(row)"
                    ></vxe-input>
                  </template>
                </vxe-column>
                <vxe-column
                  field="price"
                  title="退货单价"
                  width="120"
                  :edit-render="{ autofocus: '.vxe-input--inner' }"
                >
                  <template #edit="{ row }">
                    <vxe-input
                      :disabled="priceDisabled"
                      v-model="row.price"
                      @blur="pricegoods(row)"
                      @change="changeInput(row)"
                    ></vxe-input>
                  </template>
                </vxe-column>
                <vxe-column
                  style="color: #f62b4e"
                  field="refundAmount"
                  title="退货金额"
                  width="100"
                >
                  <template #default="{ row }">
                    <span class="colorF6">&yen;{{ row.refundAmount }}</span>
                  </template>
                </vxe-column>
              </vxe-table>
            </div>
          </div>

          <!-- 提交 -->
          <div class="present">
            <Button
              class="btn1"
              :loading="loading"
              @click="handleSubmit('formValidate')"
              >提交</Button
            >
          </div>

          <!-- 订单详情 -->
          <div class="indentparticulars">
            <div class="headline">
              <span>订单详情</span>
            </div>
            <div class="content">
              <div class="content_top">
                <Row>
                  <Col span="6">
                    <span>卖家 :&nbsp;</span>
                    <span>{{ particulars.buyShopName }}</span>
                    <xiaopei
                      :oppositeTenantId="particulars.buyTenantId"
                      :orderId="particulars.id"
                    >
                      <i class="iconfont icon-a-lujing162"></i>
                    </xiaopei>
                  </Col>
                  <Col span="6">
                    <span>订单编号 :&nbsp;</span>
                    <span class="span1">
                      <!-- <a :href="/orderInformation"></a> -->
                      <router-link
                        rel="opener"
                        :to="{
                          path: '/orderDetails',
                          query: {
                            id: particulars.code,
                            orderId: particulars.id
                          }
                        }"
                        >{{ particulars.code }}</router-link
                      >
                    </span>
                  </Col>
                  <Col span="6">
                    <span>商品金额 :&nbsp;</span>
                    <span style="margin-left: 5px"
                      >&yen;{{ particulars.goodsAmount }}</span
                    >
                  </Col>
                </Row>

                <div style="margin-top: 40px">
                  <Row>
                    <Col span="6">
                      <span>运费 :&nbsp;</span>
                      <span style="margin-left: 5px"
                        >&yen;&nbsp;{{
                          particulars.freight ? particulars.freight : 0
                        }}</span
                      >
                    </Col>
                    <Col span="6">
                      <span>实付款 :&nbsp;</span>
                      <span style="margin-left: 5px"
                        >&yen;{{ particulars.payMoney }}</span
                      >
                    </Col>
                    <Col span="6">
                      <span>数量 :&nbsp;</span>
                      <span style="margin-left: 5px">{{
                        particulars.count
                      }}</span>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 80px"></div>
  </div>
</template>

<script>
import headerTop from '@/views/base/common/header-top.vue'
import upload from '@/views/base/uploadify/upload.vue'
import xiaopei from '@/views/xiaopei/index.vue'
import {
  // getcause,
  getparticulars,
  salesnumber,
  entirerefund
} from '@/api/refund/index'
import { freightdata, getType } from '@/api/freight/index'
export default {
  components: {
    headerTop,
    upload,
    xiaopei
  },
  data() {
    return {
      priceDisabled: false,
      examine: false,
      step: 2,
      details: '', // 详情得id
      refundlabel: '', // 退货原因汉字
      // 表单的数据
      formValidate: {
        type: '', // 类型
        reason: '', // 原因
        logo: '', // 照片
        refundexplain: '', // 退货说明
        uploading: '' // 上传凭证
      },
      // reasonlist: [], // 退货原因数据
      // 表单的验证规则
      ruleValidate: {
        type: [
          {
            required: true,
            message: '请选择服务类型',
            trigger: 'blur'
          }
        ],
        reason: [
          {
            required: true,
            message: '请选择退货原因',
            trigger: 'blur'
          }
        ]
      },
      // 第二个表格数据
      tableData3: [
        // {
        //   id: 10001,
        //   partsName: '奔驰水箱散热器A1695001803', // 配件名称
        //   buyquantity: '购买数量', // 购买数量
        //   returnable: '可退数量', // 可退数量
        //   returns: '退货数量', // 退货数量
        //   returnsprice: '退货单价', // 退货单价
        //   returnsmoney: '退货金额' // 退货金额
        // }
      ],
      // 表格的验证规则
      validRules: {
        // ^[1-9]\d*$
        refundNumber: [
          { required: true, message: '请输入退货数量', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入退货单价', trigger: 'blur' },
          {
            pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
            message: '最多输入两位小数',
            trigger: 'blur'
          }
        ]
      },
      ceshi: {
        id: '1',
        name: '大王盖地虎'
      },
      certificatelist: [], //上传的凭证
      particulars: {}, // 订单详情
      returnedlist: [], // 退货商品
      partId: '', //配件id
      refundNumber: '', // 配件的退货数量
      options: {
        size: 5,
        fileType: [
          'png',
          'jpg',
          'jpeg',
          'bmp',
          'gif',
          'webp',
          'psd',
          'svg',
          'tiff'
        ],
        optionbtn8: true
      },
      ceshi12: [],
      loading: false, // 转圈
      datalist: [],
      typeList:[]
    }
  },
  created() {
    // this.returnscause()
    this.orderdetails()
  },
  methods: {
    // 订单详情得数据
    async orderdetails() {
      console.log('订单详情')
      this.details = this.$route.query.details
      this.refundType = this.$route.query.refundType
      console.log(this.refundType)
      // const res = await getparticulars(this.details)
      // const res = await getparticulars('1481092916034785281')
      if (this.details) {
        const res = await getparticulars({ orderId: this.details, type: 2 })
        console.log(res)
        this.particulars = res.data
        this.tableData3 = res.data.children
        this.datalist = JSON.parse(JSON.stringify(res.data.children))
        console.log(this.particulars)
        this.getType()
      }
    },
    // 获取退货退款选项
    async getType() {
      const res = await getType({ code: this.particulars.code })
      console.log(res)
      if (res.status) {
        this.typeList = res.data
        this.formValidate.type = this.typeList[0].id
      }
    },
    changeInput(row) {
      console.log(typeof row.price)
      row.price = row.price.toString().replace(/\s*/g, '')
      console.log('33333')
    },
    // 退货原因
    // async returnscause() {
    //   const res = await getcause(['TKYY'])
    //   console.log(res)
    //   if (res.code == 0) {
    //     this.reasonlist = res.data.TKYY
    //   }
    // },
    // 提交
    async handleSubmit(name) {
      // this.$refs.formValidate.validate(async (valid) => {
      //   if (valid) {
      const data1 = this.$refs.xTable3.getCheckboxRecords()
      console.log(data1)
      if (data1.length == 0) {
        this.$Message.destroy()
        this.$Message.warning('请选择商品')
      } else {
        const $table = this.$refs.xTable3
        const errMap = await $table.validate(data1).catch((errMap) => errMap)
        if (errMap) {
          // this.$Message.warning('验证错误')
        } else {
          this.loading = true
          const res = await freightdata({
            reason: this.formValidate.reason, // 售后原因
            remark: this.formValidate.desc, //退货说明
            ordersId: this.particulars.id, //订单id
            type: this.formValidate.type, //售后类型(1退货、2退货、3退货退货)
            imagesUrl: this.certificatelist, //退货图片地址(多个用英文逗号隔开)
            refundedGoodsList: this.partIdlist, //退货商品
            content: this.refundlabel,
            isAfterSale: 1
          })
          console.log(res)
          if (res.status) {
            this.loading = false
            res.refundType = this.formValidate.type
            this.$emit('show1', res)
            this.$Message.success('提交订单成功,等待卖家处理')
          } else {
            this.loading = false
          }
          // else {
          //   this.$Message.error(res.message)
          // }
          // this.$router.push({
          //   path: '/reimburse',
          //   query: { searchContent: this.ceshi }
          // })
        }
      }
      // }
      // })
    },
    // 退货退款不同状态退款单价是否编辑
    editActivedEvent({ rowIndex, row }) {
      console.log(rowIndex, row)
      if (this.formValidate.type == 3) {
        this.priceDisabled = true
      } else {
        this.priceDisabled = false
      }
    },
    // 售后类型改变时
    change(value) {
      console.log(value)
      console.log(this.datalist)
      this.tableData3 = JSON.parse(JSON.stringify(this.datalist))
    },
    // 取消
    // handleReset(name) {
    //   this.$refs[name].resetFields()
    // },
    // 表单选择多选框
    selectChangeEvent2({ checked, records }) {
      // console.log(checked ? '勾选事件' : '取消事件', records)
      console.log(records)
      this.partIdlist = records
      console.log(this.partIdlist)
      this.partIdlist = this.partIdlist.map((item) => {
        return {
          partId: item.partId,
          refundNumber: item.refundNumber,
          refundAmount: item.refundAmount,
          refundPrice: item.price,
          storeId: item.storeId
        }
      })
      console.log(this.partIdlist)
    },
    // 删除凭证
    deletelogo(file) {
      console.log(file)
      this.certificatelist = this.certificatelist.filter((item) => {
        return item !== file
      })
      console.log(this.certificatelist)
    },
    pricegoods(row) {
      this.salesgoods(row)
    },
    async salesgoods(row) {
      console.log(row)
      // let refundNumber = JSON.parse(JSON.stringify(row.refundNumber))
      // row.refundNumber = refundNumber.toString().replace(/\s*/g, '')
      // row.refundNumber row.refundNumber.toString().replace(/\s*/g, '')
      // console.log(row.refundNumber)
      this.partId = row.partId
      this.refundNumber = row.refundNumber
      const $table = this.$refs.xTable3
      const errMap = await $table.validate(row).catch((errMap) => errMap)
      if (errMap) {
        // this.$Message.destroy()
        // this.$Message.error('请输入正整数')
      } else {
        if (this.refundNumber) {
          const res = await salesnumber({
            orderId: this.particulars.id, // 订单id
            partId: this.partId, // 商品id
            refundNumber: this.refundNumber, // 退货数量
            price: row.price,
            storeId: row.storeId,
            type: this.formValidate.type
          })
          console.log(res)
          row.refundAmount = res.data
          const data = this.$refs.xTable3.getCheckboxRecords()
          console.log(data)
          this.partIdlist = data
          console.log(this.partIdlist)
          this.partIdlist = this.partIdlist.map((item) => {
            return {
              partId: item.partId,
              refundNumber: item.refundNumber,
              refundAmount: item.refundAmount,
              refundPrice: item.price,
              storeId: item.storeId
            }
          })
        }
      }
    },
    // 上传凭证
    certificate(res, b) {
      console.log(res) // 图片
      console.log(b) // 名字
      console.log(this.certificatelist) // 接受的list
      if (this.certificatelist.length < 10) {
        this.certificatelist.push(res.url)
      } else {
        return false
      }
    },
    // 退货原因name
    account(a) {
      this.refundlabel = a.label
    },
    // vxe自带的全选
    async selectChangeEventAll({ checked, records }) {
      console.log('开大会')
      if (this.formValidate.type) {
        if (checked) {
          const res = await entirerefund(
            this.details + '/' + this.formValidate.type
          )
          this.tableData3 = res.data.list
          this.partIdlist = this.tableData3.map((item) => {
            return {
              partId: item.partId,
              refundNumber: item.refundNumber,
              refundPrice: item.price,
              refundAmount: item.refundAmount,
              storeId: item.storeId
            }
          })
          console.log(this.partIdlist)
          this.$refs.xTable3.setCheckboxRow(this.tableData3, true)
        } else {
          this.$refs.xTable3.setCheckboxRow(this.tableData3, false)
        }
      } else {
        this.$refs.xTable3.clearCheckboxRow()
        this.$Message.warning('请选择服务类型')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
